import React, { useState, useEffect } from "react";
import Header from "../../layouts/Header";
import Footer from "../../layouts/Footer";
import { Link, useNavigate, useParams } from "react-router-dom";
import Select from 'react-select';
import { 
  Card, 
  Row, 
  Col, 
  Form, 
  Button, 
  Spinner, 
  Alert,
  Tab,
  Tabs,
  Badge,
  Container
} from "react-bootstrap";
import axios from "axios";
import {
  ArrowLeft,
  Save,
  Building,
  Phone,
  Envelope,
  GeoAlt,
  CreditCard,
  Calendar,
  Person,
  Briefcase,
  Check,
  X,
  ExclamationCircle,
  InfoCircle,
  FileText,
  Wallet,
  Clock,
  Bank2,
  CashStack,
  Truck,
  Pencil,
  Bug,
  PersonBadge,
  ShieldCheck,
  Globe2,
  CardText,
  Hash
} from "react-bootstrap-icons";

const API_BASE_URL = process.env.REACT_APP_API_URL;
const TAXPAYERS_ENDPOINT = `${API_BASE_URL}/taxpayers`;
const FORMES_ENDPOINT = `${API_BASE_URL}/formes`;

const modesPaiement = [
  { value: "", label: "Sélectionner un mode de paiement" },

];

export default function EditContribuable() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(true);
  const [categories, setCategories] = useState([]);
  const [loadingCategories, setLoadingCategories] = useState(false);
  const [formesJuridiques, setFormesJuridiques] = useState([]);
  const [loadingFormes, setLoadingFormes] = useState(false);
  const [alertMessage, setAlertMessage] = useState({ show: false, message: '', type: 'info' });
  const [activeTab, setActiveTab] = useState('informations');
  const [showDebug, setShowDebug] = useState(false);
  const [contribuableData, setContribuableData] = useState(null);
  // Ajoutez avec les autres useState
const [modesPaiementList, setModesPaiementList] = useState([]);
const [loadingModesPaiement, setLoadingModesPaiement] = useState(false);

  const [formData, setFormData] = useState({
    nom_contribuable: "",
    admin_full_name: "",
    first_name: "",
    forme_juridique: "",
    activite_contribuable: "",
    telephone: "",
    email: "",
    adresse: "",
    mode_paiement: "",
    date_paiement: "",
    // Nouveaux champs
    business_unique_id: "",
    id_nat: "",
    rccm: "",
    nif: "",
    localite_id: ""
  });

  // Transformer les catégories pour react-select
  const categoryOptions = categories.map(cat => ({
    value: String(cat.id_export),
    label: `${cat.name} - ${cat.cat_name }`
  }));

  // Gestionnaire pour react-select
  const handleCategoryChange = (selectedOption) => {
    const newValue = selectedOption ? selectedOption.value : '';
    setFormData(prev => ({
      ...prev,
      activite_contribuable: newValue
    }));
  };

  const getAuthToken = () => sessionStorage.getItem("authToken");

  const getHeaders = () => {
    const token = getAuthToken();
    const headers = { "Content-Type": "application/json", "Accept": "application/json" };
    if (token) headers["Authorization"] = `Bearer ${token}`;
    return headers;
  };

  // Charger les catégories
  const fetchCategories = async () => {
    try {
      setLoadingCategories(true);
      const response = await axios.get(`${API_BASE_URL}/activites`, { headers: getHeaders() });
      if (response.data && Array.isArray(response.data)) {
        setCategories(response.data);
      }
    } catch (error) {
      console.error("Erreur chargement activité:", error);
    } finally {
      setLoadingCategories(false);
    }
  };



  // Charger les modes de paiement depuis l'API
const fetchModesPaiement = async () => {
  try {
    setLoadingModesPaiement(true);
    const response = await axios.get(`${API_BASE_URL}/payments/methods`, { headers: getHeaders() });
    if (response.data && Array.isArray(response.data)) {
      setModesPaiementList(response.data);
      console.log('Modes de paiement chargés:', response.data);
    }
  } catch (error) {
    console.error("Erreur chargement modes de paiement:", error);
    setModesPaiementList([]);
  } finally {
    setLoadingModesPaiement(false);
  }
};

  // Charger les formes juridiques depuis l'API
// Charger les formes juridiques depuis l'API
const fetchFormesJuridiques = async () => {
  try {
    setLoadingFormes(true);
    const response = await axios.get(FORMES_ENDPOINT, { headers: getHeaders() });
    if (response.data && Array.isArray(response.data)) {
      setFormesJuridiques(response.data);
      console.log('Formes juridiques chargées:', response.data);
    }
  } catch (error) {
    console.error("Erreur chargement formes juridiques:", error);
    setFormesJuridiques([]);
  } finally {
    setLoadingFormes(false);
  }
};

  // Charger les données du contribuable
  const fetchContribuable = async () => {
    try {
      setLoadingData(true);
      const response = await axios.get(`${TAXPAYERS_ENDPOINT}/${id}`, { headers: getHeaders() });
      
      // La réponse est un objet directement, pas un tableau
      const data = response.data;
      setContribuableData(data);
      
      console.log('Données reçues:', data);
      
      // Remplir le formulaire avec les données reçues
      setFormData({
        nom_contribuable: data.nom_contribuable || "",
        admin_full_name: data.admin_full_name || data.super_admin?.full_name || "",
        first_name: data.first_name || "",
        forme_juridique: data.forme_juridique !== undefined && data.forme_juridique !== null ? String(data.forme_juridique) : "",
        activite_contribuable: data.activite_contribuable ? String(data.activite_contribuable) : "",
        telephone: data.telephone || "",
        email: data.email || data.super_admin?.email || "",
        adresse: data.adresse || "",
        mode_paiement: data.mode_paiement || "",
        date_paiement: data.date_paiement || "",
        business_unique_id: data.business_unique_id || "",
        id_nat: data.id_nat || "",
        rccm: data.rccm || "",
        nif: data.nif || "",
        localite_id: data.localite_id || ""
      });
      
    } catch (error) {
      console.error("Erreur chargement contribuable:", error);
      showAlert("Erreur lors du chargement des données", "danger");
    } finally {
      setLoadingData(false);
    }
  };

  useEffect(() => {
    fetchCategories();
    fetchFormesJuridiques();
    fetchContribuable();
    fetchModesPaiement();
  }, [id]);

  const showAlert = (message, type = 'danger', duration = 5000) => {
    setAlertMessage({ show: true, message, type });
    if (duration > 0) setTimeout(() => setAlertMessage({ show: false, message: '', type: 'info' }), duration);
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  
  console.log('=== DONNÉES ENVOYÉES ===');
  console.log(JSON.stringify(formData, null, 2));
  
  if (!formData.nom_contribuable?.trim()) {
    showAlert("La dénomination est obligatoire", 'danger');
    return;
  }
  
  if (!formData.telephone?.trim()) {
    showAlert("Le téléphone est obligatoire", 'danger');
    return;
  }

  setLoading(true);
  
  try {
    const submitData = {
      nom_contribuable: formData.nom_contribuable.trim(),
      admin_full_name: formData.admin_full_name?.trim() || "",
      first_name: formData.first_name?.trim() || "",
      forme_juridique: formData.forme_juridique ? Number(formData.forme_juridique) : null,
      activite_contribuable: formData.activite_contribuable || null,
      telephone: formData.telephone.trim(),
      email: formData.email || "",
      admin_email: formData.email || "",
      adresse: formData.adresse || "",
      mode_paiement: formData.mode_paiement || null,  // Envoie le code (ex: "virement", "cash", etc.)
      date_paiement: formData.date_paiement || null,
      business_unique_id: formData.business_unique_id || null,
      id_nat: formData.id_nat || null,
      rccm: formData.rccm || null,
      nif: formData.nif || null,
      localite_id: formData.localite_id || null,
      is_active: true
    };

    console.log('Payload envoyé à l\'API:', submitData);
    
    const response = await axios.patch(`${TAXPAYERS_ENDPOINT}/${id}`, submitData, { headers: getHeaders() });
    
    console.log('Réponse reçue:', response.data);
    
    showAlert("Contribuable mis à jour avec succès !", 'success');
    
    setTimeout(() => {
      fetchContribuable();
    }, 1500);
    
  } catch (error) {
    console.error('Erreur détaillée:', error.response?.data);
    
    let errorMessage = "Erreur lors de la mise à jour";
    if (error.response?.data?.message) {
      errorMessage = error.response.data.message;
    } else if (error.response?.data?.errors) {
      errorMessage = Object.values(error.response.data.errors).flat().join(", ");
    } else if (error.message) {
      errorMessage = error.message;
    }
    showAlert(errorMessage, 'danger');
  } finally {
    setLoading(false);
  }
};
  if (loadingData) {
    return (
      <React.Fragment>
        <Header />
        <div className="main main-app p-3 p-lg-4">
          <div className="container-fluid text-center py-5">
            <Spinner animation="border" variant="primary" size="lg" />
            <p className="mt-3">Chargement des données...</p>
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <Header />
      <div className="main main-app p-3 p-lg-4" style={{ background: '#f0f2f5', minHeight: '100vh' }}>
        <Container fluid>
          {/* En-tête */}
          <div className="d-flex justify-content-between align-items-center mb-4">
            <div>
              <div className="d-flex align-items-center gap-3 mb-2">
                <Button 
                  variant="outline-secondary" 
                  size="sm" 
                  onClick={() => navigate('/agent/contribuables/search')}
                  className="d-flex align-items-center gap-1"
                >
                  <ArrowLeft size={14} />
                  Retour
                </Button>
                <Badge bg="primary" className="px-3 py-2">
                  <ShieldCheck className="me-1" size={12} />
                  ID: {contribuableData?.contribuable_id || id}
                </Badge>
                <Badge bg="info" className="px-3 py-2">
                  <Hash className="me-1" size={12} />
                  N°: {contribuableData?.business_unique_id || 'N/A'}
                </Badge>


                {/* Afficher la forme juridique actuelle */}
{formData.forme_juridique && (
  <div className="mt-2">
    <Badge bg="info" className="px-3 py-2">
      <Building className="me-1" size={12} />
      Forme actuelle: {
        formesJuridiques.find(f => String(f.forme_id) === String(formData.forme_juridique))?.libelle 
        || formData.forme_juridique
      }
    </Badge>
  </div>
)}
              </div>
              <div>
                <h3 className="mb-1 fw-semibold">Modifier le contribuable</h3>
                <p className="text-muted mb-0">Mettez à jour les informations du contribuable</p>
              </div>
            </div>
            <Button 
              variant="outline-secondary" 
              size="sm"
              onClick={() => setShowDebug(!showDebug)}
              className="d-flex align-items-center gap-1"
            >
              <Bug size={14} />
              {showDebug ? 'Cacher debug' : 'Afficher debug'}
            </Button>
          </div>

          {/* Panneau de debug */}
          {showDebug && (
            <Card className="mb-4">
              <Card.Header className="bg-dark text-white">
                <strong>🔧 Mode Débogage</strong>
              </Card.Header>
              <Card.Body className="bg-light">
                <Row>
                  <Col md={6}>
                    <Form.Label className="fw-bold">📋 Données du formulaire</Form.Label>
                    <pre className="bg-dark text-white p-3 rounded" style={{ fontSize: '12px', maxHeight: '300px', overflow: 'auto' }}>
                      {JSON.stringify(formData, null, 2)}
                    </pre>
                  </Col>
                  <Col md={6}>
                    <Form.Label className="fw-bold">📋 Données brutes API</Form.Label>
                    <pre className="bg-dark text-white p-3 rounded" style={{ fontSize: '12px', maxHeight: '300px', overflow: 'auto' }}>
                      {JSON.stringify(contribuableData, null, 2)}
                    </pre>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          )}

          {/* Formulaire principal */}
          <Card className="border-0 shadow-sm">
            <Card.Header className="bg-white border-bottom px-4 py-3">
              <Tabs
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                className="border-0"
              >
                <Tab 
                  eventKey="informations" 
                  title={
                    <span className="d-flex align-items-center gap-2">
                      <Building size={16} />
                      Informations générales
                    </span>
                  }
                />
                <Tab 
                  eventKey="identifiant" 
                  title={
                    <span className="d-flex align-items-center gap-2">
                      <CardText size={16} />
                      Documents & Identifiants
                    </span>
                  }
                />
                <Tab 
                  eventKey="paiement" 
                  title={
                    <span className="d-flex align-items-center gap-2">
                      <CreditCard size={16} />
                      Préférence de paiement
                    </span>
                  }
                />
              </Tabs>
            </Card.Header>
            
            <Card.Body className="p-4">
              <Form onSubmit={handleSubmit}>
                {/* Onglet Informations générales */}
                {activeTab === 'informations' && (
                  <>
                    {/* Section Identification */}
                    <div className="mb-4">
                      <div className="d-flex align-items-center gap-2 mb-3 pb-2 border-bottom">
                        <Building className="text-primary" size={18} />
                        <h6 className="mb-0 fw-semibold text-primary">Identification</h6>
                      </div>
                      <Row className="g-3">
                        <Col md={12}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">
                              Dénomination <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="nom_contribuable"
                              value={formData.nom_contribuable}
                              onChange={handleChange}
                              placeholder="Nom de l'entreprise ou du contribuable"
                              className="py-2"
                              required
                            />
                            <Form.Text className="text-muted">
                              Nom complet de l'entreprise ou du contribuable
                            </Form.Text>
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>

                    {/* Section Identité */}
                    <div className="mb-4">
                      <div className="d-flex align-items-center gap-2 mb-3 pb-2 border-bottom">
                        <Person className="text-primary" size={18} />
                        <h6 className="mb-0 fw-semibold text-primary">Identité</h6>
                      </div>
                      <Row className="g-3">
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">
                              <PersonBadge className="me-1" size={14} />
                              Nom complet
                            </Form.Label>
                            <Form.Control 
                              type="text" 
                              name="admin_full_name" 
                              value={formData.admin_full_name} 
                              onChange={handleChange} 
                              placeholder="Nom et prénom de l'administrateur"
                              className="py-2"
                            />
                            <Form.Text className="text-muted">
                              Nom et prénom de l'administrateur
                            </Form.Text>
                          </Form.Group>
                        </Col>
                        <Col md={6}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">Prénom</Form.Label>
                            <Form.Control 
                              type="text" 
                              name="first_name" 
                              value={formData.first_name} 
                              onChange={handleChange} 
                              placeholder="Prénom"
                              className="py-2"
                            />
                            <Form.Text className="text-muted">
                              Prénom du contact principal
                            </Form.Text>
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>

                    {/* Section Activité */}
                    <div className="mb-4">
                      <div className="d-flex align-items-center gap-2 mb-3 pb-2 border-bottom">
                        <Briefcase className="text-primary" size={18} />
                        <h6 className="mb-0 fw-semibold text-primary">Activité</h6>
                      </div>
                      <Row className="g-3">
                       <Col md={6}>
  <Form.Group>
    <Form.Label className="fw-semibold">Forme juridique</Form.Label>
    <Form.Select 
      name="forme_juridique" 
      value={formData.forme_juridique} 
      onChange={handleChange}
      className="py-2"
      disabled={loadingFormes}
    >
      <option value="">-- Sélectionner une forme juridique --</option>
      {loadingFormes ? (
        <option disabled>Chargement...</option>
      ) : (
        formesJuridiques.map(f => (
          <option key={f.id} value={f.forme_id}>
            {f.libelle} ({f.code})
          </option>
        ))
      )}
    </Form.Select>
    {formData.forme_juridique && !loadingFormes && (
      <Form.Text className="text-muted">
        {formesJuridiques.find(f => String(f.forme_id) === String(formData.forme_juridique))?.description || ''}
      </Form.Text>
    )}
  </Form.Group>
</Col>

                        <Col md={6}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">Activité</Form.Label>
                            <Select
                              options={categoryOptions}
                              value={categoryOptions.find(opt => String(opt.value) === String(formData.activite_contribuable)) || null}
                              onChange={handleCategoryChange}
                              isLoading={loadingCategories}
                              isDisabled={loadingCategories}
                              placeholder="Rechercher une activité..."
                              noOptionsMessage={() => "Aucune activité trouvée"}
                              className="react-select"
                              classNamePrefix="select"
                            />
                            <Form.Text className="text-muted">
                              Code activité: {formData.activite_contribuable || 'Non défini'}
                            </Form.Text>
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>

                    {/* Section Contact */}
                    <div className="mb-4">
                      <div className="d-flex align-items-center gap-2 mb-3 pb-2 border-bottom">
                        <Phone className="text-primary" size={18} />
                        <h6 className="mb-0 fw-semibold text-primary">Contact</h6>
                      </div>
                      <Row className="g-3">
                        <Col md={4}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">
                              Téléphone <span className="text-danger">*</span>
                            </Form.Label>
                            <Form.Control 
                              type="tel" 
                              name="telephone" 
                              value={formData.telephone} 
                              onChange={handleChange} 
                              placeholder="+241 XX XXX XXX"
                              className="py-2"
                              required 
                            />
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">
                              <Envelope className="me-1" size={14} />
                              Email
                            </Form.Label>
                            <Form.Control 
                              type="email" 
                              name="email" 
                              value={formData.email} 
                              onChange={handleChange} 
                              placeholder="exemple@email.com"
                              className="py-2"
                            />
                          </Form.Group>
                        </Col>
                        <Col md={4}>
                          <Form.Group>
                            <Form.Label className="fw-semibold">
                              <GeoAlt className="me-1" size={14} />
                              Adresse complète
                            </Form.Label>
                            <Form.Control 
                              type="text" 
                              name="adresse" 
                              value={formData.adresse} 
                              onChange={handleChange} 
                              placeholder="Adresse complète"
                              className="py-2"
                            />
                          </Form.Group>
                        </Col>
                      </Row>
                    </div>
                  </>
                )}

                {/* Onglet Documents & Identifiants */}
                {activeTab === 'identifiant' && (
                  <div className="mb-4">
                    <div className="d-flex align-items-center gap-2 mb-3 pb-2 border-bottom">
                      <FileText className="text-primary" size={18} />
                      <h6 className="mb-0 fw-semibold text-primary">Documents et identifiants</h6>
                    </div>
                    
                    <Row className="g-3">
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label className="fw-semibold">
                            <Hash className="me-1" size={14} />
                            Business Unique ID
                          </Form.Label>
                          <Form.Control 
                            type="text" 
                            name="business_unique_id" 
                            value={formData.business_unique_id} 
                            onChange={handleChange} 
                            placeholder="Identifiant unique de l'entreprise"
                            className="py-2"
                          />
                        </Form.Group>
                      </Col>
                      
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label className="fw-semibold">
                            <CardText className="me-1" size={14} />
                            ID National
                          </Form.Label>
                          <Form.Control 
                            type="text" 
                            name="id_nat" 
                            value={formData.id_nat} 
                            onChange={handleChange} 
                            placeholder="Identifiant national"
                            className="py-2"
                          />
                        </Form.Group>
                      </Col>
                      
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label className="fw-semibold">RCCM</Form.Label>
                          <Form.Control 
                            type="text" 
                            name="rccm" 
                            value={formData.rccm} 
                            onChange={handleChange} 
                            placeholder="Registre du Commerce et du Crédit Mobilier"
                            className="py-2"
                          />
                          <Form.Text className="text-muted">
                            Numéro d'immatriculation au registre du commerce
                          </Form.Text>
                        </Form.Group>
                      </Col>
                      
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label className="fw-semibold">NIF</Form.Label>
                          <Form.Control 
                            type="text" 
                            name="nif" 
                            value={formData.nif} 
                            onChange={handleChange} 
                            placeholder="Numéro d'Identification Fiscale"
                            className="py-2"
                          />
                          <Form.Text className="text-muted">
                            Numéro d'identification fiscale
                          </Form.Text>
                        </Form.Group>
                      </Col>
                      
                      <Col md={12}>
                        <Form.Group>
                          <Form.Label className="fw-semibold">
                            <Globe2 className="me-1" size={14} />
                            Localité
                          </Form.Label>
                          <Form.Control 
                            type="text" 
                            name="localite_id" 
                            value={formData.localite_id} 
                            onChange={handleChange} 
                            placeholder="Code localité"
                            className="py-2"
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Card className="bg-light mt-4">
                      <Card.Body className="py-3">
                        <div className="d-flex align-items-center gap-2">
                          <InfoCircle className="text-info" size={18} />
                          <small className="text-muted">
                            Ces informations sont utilisées pour l'identification légale et fiscale du contribuable.
                          </small>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                )}

                {/* Onglet Préférence de paiement */}
                {activeTab === 'paiement' && (
                  <div className="mb-4">
                    <div className="d-flex align-items-center gap-2 mb-3 pb-2 border-bottom">
                      <CreditCard className="text-primary" size={18} />
                      <h6 className="mb-0 fw-semibold text-primary">Préférence de paiement</h6>
                    </div>
                    
                    <Row className="g-3">
                      <Col md={6}>
  <Form.Group>
    <Form.Label className="fw-semibold">
      <Wallet className="me-1" size={14} />
      Mode de paiement préféré
    </Form.Label>
    <Form.Select 
      name="mode_paiement" 
      value={formData.mode_paiement} 
      onChange={handleChange}
      className="py-2"
      disabled={loadingModesPaiement}
    >
      <option value="">-- Sélectionner un mode de paiement --</option>
      {loadingModesPaiement ? (
        <option disabled>Chargement...</option>
      ) : (
        modesPaiementList.map(m => (
          <option key={m.id} value={m.code}>
            {m.libelle}
          </option>
        ))
      )}
    </Form.Select>
    {formData.mode_paiement && !loadingModesPaiement && (
      <Form.Text className="text-muted">
        Mode sélectionné: {
          modesPaiementList.find(m => m.code === formData.mode_paiement)?.libelle || formData.mode_paiement
        }
      </Form.Text>
    )}
  </Form.Group>
</Col>
                      
                      <Col md={6}>
                        <Form.Group>
                          <Form.Label className="fw-semibold">
                            <Calendar className="me-1" size={14} />
                            Date de paiement préférée
                          </Form.Label>
                          <Form.Control 
                            type="date" 
                            name="date_paiement" 
                            value={formData.date_paiement} 
                            onChange={handleChange}
                            className="py-2"
                          />
                        </Form.Group>
                      </Col>
                    </Row>

                    <Card className="bg-light mt-4">
                      <Card.Body className="py-3">
                        <div className="d-flex align-items-center gap-2">
                          <InfoCircle className="text-info" size={18} />
                          <small className="text-muted">
                            Ces préférences seront utilisées pour les rappels de paiement automatiques.
                          </small>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                )}

                <hr className="my-4" />
                
                <div className="d-flex gap-3 justify-content-end">
                  <Button 
                    type="submit" 
                    variant="primary" 
                    disabled={loading}
                    className="px-4 py-2"
                  >
                    {loading ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        Enregistrement...
                      </>
                    ) : (
                      <>
                        <Save className="me-2" size={16} />
                        Enregistrer les modifications
                      </>
                    )}
                  </Button>
                </div>
              </Form>

              {alertMessage.show && (
                <div className="mt-4">
                  <Alert 
                    variant={alertMessage.type} 
                    dismissible 
                    onClose={() => setAlertMessage({ show: false, message: '', type: 'info' })}
                    className="border-0"
                  >
                    <div className="d-flex align-items-center">
                      {alertMessage.type === 'success' ? <Check className="me-2 fs-5" /> :
                       alertMessage.type === 'danger' ? <X className="me-2 fs-5" /> :
                       <ExclamationCircle className="me-2 fs-5" />}
                      <span className="fw-medium">{alertMessage.message}</span>
                    </div>
                  </Alert>
                </div>
              )}
            </Card.Body>
          </Card>
        </Container>
        <Footer />
      </div>

      <style>{`
        .nav-tabs {
          border-bottom: none;
        }
        
        .nav-tabs .nav-link {
          border: none;
          color: #6c757d;
          padding: 10px 20px;
          font-weight: 500;
          transition: all 0.2s ease;
          border-radius: 8px;
          margin-right: 8px;
        }
        
        .nav-tabs .nav-link:hover {
          color: #0d6efd;
          background-color: #f8f9fa;
        }
        
        .nav-tabs .nav-link.active {
          color: #0d6efd;
          background-color: #e7f1ff;
        }
        
        .form-control:focus, .form-select:focus {
          border-color: #0d6efd;
          box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.1);
        }
        
        .react-select {
          z-index: 10;
        }
        
        .select__control {
          border-color: #dee2e6;
          box-shadow: none;
        }
        
        .select__control:hover {
          border-color: #0d6efd;
        }
        
        .select__control--is-focused {
          border-color: #0d6efd;
          box-shadow: 0 0 0 0.2rem rgba(13, 110, 253, 0.1);
        }
        
        .btn {
          transition: all 0.2s ease;
          border-radius: 8px;
        }
        
        .btn:hover {
          transform: translateY(-1px);
        }
        
        .card {
          border-radius: 12px;
        }
        
        .form-label {
          font-size: 0.9rem;
          margin-bottom: 0.5rem;
        }
      `}</style>
    </React.Fragment>
  );
}